const picFrom = (raw) => {
  if (!raw) return null;
  if (typeof raw === 'string' && raw.trim()) return raw;
  if (typeof raw !== 'object' || Array.isArray(raw)) return null;
  const nested = raw.pic || raw.image || raw.url || raw.img || raw.picture || raw.photo;
  if (nested && typeof nested === 'object') {
    return picFrom(nested);
  }
  return typeof nested === 'string' && nested.trim() ? nested : null;
};

const kitFrom = (raw, role) => {
  const pic = picFrom(raw);
  if (!pic) return null;
  const name =
    raw && typeof raw === 'object' && !Array.isArray(raw)
      ? raw.name || raw.title || null
      : null;
  return { pic, role, name };
};

export const clubIdFromTeamInfo = (info) =>
  info?.team?._id || info?._id || info?.team?.id || null;

export const clubKitsFromTeamInfo = (info) => {
  if (!info) return [];
  const team = info.team && typeof info.team === 'object' ? info.team : {};
  const home = kitFrom(
    info.homeKit || info.home_kit || team.homeKit || team.home_kit,
    'Home'
  );
  const away = kitFrom(
    info.awayKit || info.away_kit || team.awayKit || team.away_kit,
    'Away'
  );
  if (home || away) {
    return [home, away].filter(Boolean);
  }
  const selected = kitFrom(
    info.teamKit ||
      info.kit ||
      info.selectedKit ||
      team.teamKit ||
      team.kit ||
      team.selectedKit,
    'Kit'
  );
  if (selected) return [selected];
  const list = info.kits || team.kits;
  if (!Array.isArray(list)) return [];
  return list
    .map((item, index) =>
      kitFrom(item, item?.role || item?.type || `Kit ${index + 1}`)
    )
    .filter(Boolean);
};

export const opponentIdFromHome = (home) => {
  const myId = home?.teamId;
  const match = home?.matchRunning || home?.next_match;
  if (!match) return null;
  const homeId = match.home_team?._id;
  const awayId = match.away_team?._id;
  if (myId && homeId && String(homeId) === String(myId)) return awayId || null;
  if (myId && awayId && String(awayId) === String(myId)) return homeId || null;
  return null;
};

export const resolveClubKits = (info, home) => {
  const fromApi = clubKitsFromTeamInfo(info);
  if (fromApi.length) return fromApi;
  const clubId = clubIdFromTeamInfo(info);
  if (!clubId || !home) return [];
  if (home.teamId && String(clubId) === String(home.teamId)) {
    const own = kitFrom(home.teamKit, 'Kit');
    if (own) return [own];
  }
  const oppId = opponentIdFromHome(home);
  if (oppId && String(clubId) === String(oppId)) {
    const opp = kitFrom(home.opponentKit, 'Kit');
    if (opp) return [opp];
  }
  return [];
};
